
import React from 'react';

interface OrderPageHeaderProps {
  planName?: string;
  orderNumber?: string;
}

const OrderPageHeader: React.FC<OrderPageHeaderProps> = ({ planName, orderNumber }) => {
  return (
    <div className="mb-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-2">
        Order {planName || 'Reseller Pro'} Plan
      </h1>
      {orderNumber && (
        <p className="text-lg text-gray-600 mb-2">
          Order #: <span className="font-semibold">{orderNumber}</span>
        </p>
      )}
      <p className="text-gray-600">
        Complete the form below to set up your reseller account. Our team will review your application 
        and activate your account within 1-2 business days.
      </p>
    </div>
  );
};

export default OrderPageHeader;
